<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="12" xs="12" sm="5">
                    <div class="img-contactus">
                        <v-img src="https://assets.invisee.com/statis/revamp/contact_us.png" max-height="251px" max-width="324px" style="margin:auto;"></v-img>
                    </div>
                </v-col>
                <v-col class="text-left" cols="12" xs="12" sm="7">
                    <v-card class="card-concatcus">
                        <h1 class="text-center">Add Wealth in Your Ecosystem Now!</h1>
                        <p class="text-center" style="padding:0 100px;">Letakan alamat surel (e-mail) Anda di sini untuk mendapatkan info lebih
                            lanjut
                            mengenai produk dan teknologi kami.</p>
                        <v-alert outlined type="success" text v-if="info">
                            {{info}}
                        </v-alert>
                        <v-form ref="form" v-model="valid" @submit.prevent="submit">
                            <div class="form-group">
                                <v-text-field outlined label="Name" v-model="contactDetail['nama']" :rules="namaRules" rounded>
                                </v-text-field>
                            </div>
                            <div class="form-group">
                                <v-text-field outlined label="Company" v-model="contactDetail['perusahaan']"
                                    :rules="perusahaanRules" rounded>
                                </v-text-field>
                            </div>
                            <div class="form-group">
                                <v-text-field outlined label="Email" v-model="contactDetail['email']"
                                    :rules="emailRules" rounded>
                                </v-text-field>
                            </div>
                            <div class="text-center">
                                <v-btn class="text-capitalize rounded-lg" depressed color="#0082cc" dark tile large block
                                    @click="validateAndSubmit">
                                    Kirim</v-btn>
                            </div>
                        </v-form>
                    </v-card>
                </v-col>
                <!-- <v-col md="10" offset-md="1">
                    <v-card class="card-concatcus">
                        <h1 class="text-center">Add Wealth in Your Ecosystem Now!</h1>
                        <div class="line"></div>
                        <p class="text-center">Letakan alamat surel (e-mail) Anda di sini untuk mendapatkan info lebih
                            lanjut
                            mengenai produk dan teknologi kami.</p>
                        <v-alert outlined type="success" text v-if="info">
                            {{info}}
                        </v-alert>
                        <v-form ref="form" v-model="valid" @submit.prevent="submit">
                            <div class="form-group">
                                <v-text-field outlined label="Name" v-model="contactDetail['nama']" :rules="namaRules">
                                </v-text-field>
                            </div>
                            <div class="form-group">
                                <v-text-field outlined label="Company" v-model="contactDetail['perusahaan']"
                                    :rules="perusahaanRules">
                                </v-text-field>
                            </div>
                            <div class="form-group">
                                <v-text-field outlined label="Email" v-model="contactDetail['email']"
                                    :rules="emailRules">
                                </v-text-field>
                            </div>
                            <div class="text-right">
                                <v-btn class="text-capitalize" depressed color="#0082cc" dark tile x-large
                                    @click="validateAndSubmit">
                                    Kirim</v-btn>
                            </div>
                        </v-form>
                    </v-card>
                </v-col> -->
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import Vue from "vue";
    import axios from "axios";
    import {
        VueReCaptcha
    } from "vue-recaptcha-v3";
    Vue.use(VueReCaptcha, {
        siteKey: "6Lff-tcZAAAAAAJDjFGB3l7xdfqNLJRtUBzE_D1n"
    });
    export default {
        data() {
            return {
                valid: true,
                contactDetail: {
                    nama: '',
                    perusahaan: '',
                    email: '',
                },
                token: '',
                info: '',
                axiosDefaultsBaseURL: "https://fundagent-be.fundtastic.co.id/api/v1/",
                loginUserKeyAgent: "$2y$12$4Xw7LHgfH.Q6yGUDr.FXCOigr.EJdyKDjvHa6z0MPGJcsfUrYlaMS",
                loginPassKeyAgent: "$2y$12$uJ82.nfA7nxw7Ch27Ii8BOW71buXAZ07u/UzEUaYRH79j367CgSja",
                phrase: "general@fundtastic.co.id",
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
                namaRules: [
                    v => !!v || 'Name is required'
                ],
                perusahaanRules: [
                    v => !!v || 'Company is required'
                ],
            }
        },
        methods: {
            validateAndSubmit() {
                if (this.$refs.form.validate()) {
                    /* eslint-disable */
                    this.$recaptcha("contactus").then((token) => {
                        this.login();
                    });
                }
            },
            login: function () {
                axios.post(
                        this.axiosDefaultsBaseURL + 'auth/login_v2', {
                            email: window.btoa(this.loginUserKeyAgent + window.btoa(this.phrase)),
                            password: window.btoa(this.loginPassKeyAgent + window.btoa(this.phrase)),
                        }
                    )
                    .then(res => {
                        // handle success
                        // console.log(res);
                        this.token = res.data.data.token;
                        this.subscribe();
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            },
            subscribe: function () {
                axios.post(this.axiosDefaultsBaseURL + 'fundtasticplus/subscribe', {
                        type: "fundtasticplus",
                        name: this.contactDetail.nama,
                        email: this.contactDetail.email,
                        message: "subscribe from fundtasticplus.co.id",
                        metas: {
                            company: this.contactDetail.perusahaan
                        }
                    }, {
                        headers: {
                            Authorization: 'Bearer ' + this.token
                        }
                    })
                    .then(res => {
                        // handle success
                        // console.log(res);
                        this.info = res.data.data.alert;
                        this.$refs.form.reset()
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            },
        },
    }
</script>

<style scoped>
    .v-card {
        /* padding: 60px 160px; */
    }

    .card-concatcus {
        /* margin: 50px 0; */
    }

    .img-contactus{
        border-radius: 15px;
        background-color: rgba(248, 251, 255, 1);
        padding: 80px 0;
    }

    .card-concatcus.v-card.v-sheet{
        box-shadow: none;
    }

    @media screen and (max-width: 768px) {
        .v-card {
            /* padding: 30px; */
        }

        .card-concatcus {
            /* margin: 20px */
        }
    }
</style>